const config = {
  siteTitle: 'نادي الطلبة المطورين',
  siteTitleShort: 'DSC',
  siteTitleAlt: 'DSC',
  siteLogo: '/logos/logo-1024.png',
  siteUrl: 'https://dscnajah.netlify.app/',
  repo: 'https://github.com/ramideeb/DSC-AN-NAJAH',
  pathPrefix: '/',
  dateFromFormat: 'YYYY-MM-DD',
  dateFormat: 'MMMM Do, YYYY',
  siteDescription:"نادي الطلبة المطورين من جوجل في جامعة النجاح الوطنية",
  siteRss: '/rss.xml',
  googleAnalyticsID: 'UA-60278591-1',
  postDefaultCategoryID: 'تقنية',
  userName: 'dsc',
  userEmail: 'dscnajah@gmail.com',
  userTwitter: 'Dscnajah',
  gatsby_disqus_name: 'dscnajah',
  Team:[
    {
      name:"رامي ذيب",
      role:"Team Lead",
      email:"mailto:rami.theeb00@gmail.com"
    },
    {
      name:"سيما صبوح",
      role:"Challenges Co-lead",
      email:"mailto:Seema.sbouh512@gmail.com",

    },
   
    {
      name:"هبة الكرد",
      role:"StudyJams Co-lead",
      email: "mailto:hibaalkurd@gmail.com",

    },
    {
      name:"اشرف حبرمان",
      role:"Media Co-lead",
      email: "mailto:ashraf.habrumman@gmail.com",
    },
    {
      name:"دعاء شحادة",
      role:"WTM Co-lead",
      email: "mailto:Duaashehada2@gmail.com",
    },
    {
      name:"علا مرداوي",
      role:"StudyJams Co-lead",
      email: "mailto:Ola.mardawi@gmail.com",
    },
    {
      name:"عمرو عبدالسلام",
      role:"Programs Co-lead",
      email: "mailto:amrsalam@hotmail.com",
    },
  ],
  menuLinks: [
    {
      name: 'عن النادي',
      link: '/about-us/'
    },
    {
      name: 'المنشورات',
      link: '/blog/'
    },
    {
      name: 'اتصل بنا',
      link: '/contact/'
    }
  ],
  themeColor: '#3F80FF', // Used for setting manifest and progress theme colors.
  backgroundColor: '#ffffff'
};

// Make sure pathPrefix is empty if not needed
if (config.pathPrefix === '/') {
  config.pathPrefix = '';
} else {
  // Make sure pathPrefix only contains the first forward slash
  config.pathPrefix = `/${config.pathPrefix.replace(/^\/|\/$/g, '')}`;
}

// Make sure siteUrl doesn't have an ending forward slash
if (config.siteUrl.substr(-1) === '/')
  config.siteUrl = config.siteUrl.slice(0, -1);

// Make sure siteRss has a starting forward slash
if (config.siteRss && config.siteRss[0] !== '/')
  config.siteRss = `/${config.siteRss}`;

module.exports = config;
